/* eslint-disable no-restricted-syntax */
/* eslint-disable no-prototype-builtins */
/* eslint-disable react/no-danger */
import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { EventFlowMessageBubbleStyled } from './styled';
import i18n from '../../../assets/i18n';

const EventFlowMessageBubble = ({
  colorClass,
  date,
  sendType,
  statusIcon,
  deletedIcon,
  errorIcon,
  content,
  linkedMessage,
}) => {
  const responseData =
    content && content.eventParameters && content.eventParameters.flowResponse
      ? content.eventParameters.flowResponse
      : content;

  const borderStyle = '1px solid #ccc';
  const padding = '6px 12px';

  const transformObjectIntoTable = (obj, topLevel = true) => {
    const keys = Object.keys(obj)
      .filter(
        (k) =>
          !['flowToken', 'eventName', 'eventParameters', 'flowResponse'].includes(k)
      )
      .sort((a, b) => a.localeCompare(b, undefined, { sensitivity: 'base' }));

    let html = `<table style="border-collapse: collapse; border: ${borderStyle}; width: 100%; text-align: left; margin: 8px 0;" cellspacing="0">`;

    if (topLevel) {
      html += `<thead><tr><th style="background: #f5f5f5; padding: ${padding}; border: ${borderStyle};" colspan="2">${i18n.chats.flowResponse}</th></tr>`;
      html += `<tr><th style="padding: ${padding}; border: ${borderStyle};">${i18n.chats.key}</th>`;
      html += `<th style="padding: ${padding}; border: ${borderStyle};">${i18n.chats.value}</th></tr></thead><tbody>`;
    } else {
      html += '<tbody>';
    }

    keys.forEach((key) => {
      const value = obj[key];
      html += '<tr>';
      html += `<td style="padding: ${padding}; border: ${borderStyle}; font-weight: bold; vertical-align: top;">${_.escape(key)}</td>`;

      let cellContent = '';
      if (_.isArray(value)) {
        const primitive = value.every((el) => !_.isObject(el));
        if (primitive) {
          cellContent = `<ul style="padding-left: 20px; margin: 0;">${value
            .map((item) => `<li>${_.escape(item)}</li>`)
            .join('')}</ul>`;
        } else {
          cellContent = value
            .map((item) =>
              `<div style="margin-bottom: 8px;">${transformObjectIntoTable(
                item,
                false
              )}</div>`
            )
            .join('');
        }
      } else if (_.isObject(value) && value !== null) {
        cellContent = transformObjectIntoTable(value, false);
      } else {
        cellContent = _.escape(value);
      }

      html += `<td style="padding: ${padding}; border: ${borderStyle}; vertical-align: top;">${cellContent}</td>`;
      html += '</tr>';
    });

    html += '</tbody></table>';
    return html;
  };

  return (
    <EventFlowMessageBubbleStyled
      sendType={sendType}
      isThereErrorIcon={!_.isNil(errorIcon)}
    >
      {errorIcon && (
        <div
          className="error-icon-holder"
          data-tip={i18n.errors.tooltipError}
          data-offset="{'left': 5}"
        >
          {errorIcon}
        </div>
      )}
      <div className={colorClass}>
        {linkedMessage && <div className="linked-message-box">{linkedMessage}</div>}
        {deletedIcon ? (
          <div className="deleted-info-holder">
            {deletedIcon}
            <div
              className="message-text"
              dangerouslySetInnerHTML={{ __html: transformObjectIntoTable(responseData) }}
            />
          </div>
        ) : (
          <>
            <div
              className="message-text"
              dangerouslySetInnerHTML={{ __html: transformObjectIntoTable(responseData) }}
            />
            <div className="info-row">
              <p className="timespan-message">{date}</p>
              {statusIcon}
            </div>
          </>
        )}
      </div>
    </EventFlowMessageBubbleStyled>
  );
};

EventFlowMessageBubble.propTypes = {
  colorClass: PropTypes.string,
  content: PropTypes.object.isRequired,
  date: PropTypes.string,
  sendType: PropTypes.string,
  statusIcon: PropTypes.node,
  deletedIcon: PropTypes.node,
  errorIcon: PropTypes.node,
  linkedMessage: PropTypes.node,
};

export default EventFlowMessageBubble;
